module.exports = __webpack_public_path__ + "img/ab-page2-img2.1f3a5ef2.png";